<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="请输入关键字或词"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div>
          <el-button
            v-permission="['受试者脱落结果导出']"
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            >导出结果</el-button
          >
          <el-button
            v-permission="['受试者脱落脱落']"
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            v-if="statusPro !== '项目已锁定'"
            :disabled="isOngoing"
            @click="handleFallOff"
            >受试者脱落</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        stripe
        size="mini"
        :data="roleData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        border
        :cell-style="cellStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column type="selection" />
        <el-table-column prop="choice_code_combination" label="筛选号" />
        <el-table-column prop="name_abb" label="姓名缩写">
          <template slot-scope="scope">
            <div style="font-size: 12px">{{ scope.row.name_abb }}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="project.is_need_layer" label="分层因素" prop="layer_str" width="170" />
        <el-table-column label="随机号" prop="random_code_combination" />
        <el-table-column label="入组中心" prop="unit_name" width="206" />
        <el-table-column label="主要研究者" prop="doctor_name" />
        <el-table-column label="操作人员" prop="create_user_name" />
        <template
          v-if="
            project.short_name ===
              '药物涂层外周球囊导管治疗腘下动脉狭窄或闭塞性病变' ||
            $jiemai(proId)||project.id==='62b913e631c5eca8a702970d' || project.id==='661892a3a5957e087c613555'|| project.id==='678f3c9def2164132767c5c8'
          "
        >
          <el-table-column prop="random_operation_time" :label="project.id === '678f3c9def2164132767c5c8'?'签署知情时间':'随机操作时间'" width="150"
        /></template>
        <template v-else-if="!HideProjects.includes(proId)">
          <el-table-column
            v-if="project.in_group_time_name"
            prop="reg_time"
            :label="project.in_group_time_name"
            width="150"
          />
        </template>
        <el-table-column label="脱落时间" prop="fall_off_time" />
        <!-- <el-table-column v-if="isBlind" label="试验组名" prop="group_name" /> -->
        <el-table-column label="状态">
          <template>
            已脱落
          </template>
        </el-table-column>
        <el-table-column prop="group_name" :label="project.id==='62f9f0dcc43d533bd20f99a1'?'组别':'试验组名'">
          <template slot-scope="scope">
            <span v-if="project.blind_type === '双盲'&&!($store.getters.roles.includes('受试者管理查看受试者组别(双盲)') || $store.getters.isAdmin)">***</span>
          <span v-else>{{scope.row.group_name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link
              v-permission="['受试者脱落查看']"
              type="primary"
              :underline="false"
              class="edit"
              @click="handleViewFall(scope.row)"
              >查看</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--脱落-->
    <el-dialog
      center
      :visible.sync="dialogVisibleOff"
      :close-on-click-modal="false"
      width="40%"
      @close="handleCancelHas"
    >
      <div slot="title" class="title">受试者脱落</div>
      <div class="proInfo sub_style">
        <el-row class="row">
          <el-col :span="6">选择中心：</el-col>
          <el-col :span="18">
            <el-select
              v-model="unit_id"
              placeholder="请选择"
              size="mini"
              class="right"
              @change="changeUnit"
            >
              <el-option
                v-for="item in unit_list"
                :key="item.value"
                :label="item.text"
                :value="item.id"
                :disabled="!item.enable"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6" class="">筛选号：</el-col>
          <el-col :span="18">
            <el-select
              v-model="choice_code_combination_list"
              placeholder="请选择受试者"
              size="mini"
              class="right"
              :disabled="!unit_id"
            >
              <el-option
                v-for="item in users_list"
                :key="item.id"
                :disabled="item.is_unactive"
                :label="item.choice_code_combination"
                :value="item.choice_code_combination"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6" class="">脱落时间：</el-col>
          <el-col :span="18">
            <el-date-picker
              v-model="time"
              size="mini"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="">脱落原因记录：</el-col>
          <el-col :span="18">
            <el-input
              v-model="reason"
              size="mini"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
            />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          :loading="is_loading"
          v-preventReClick
          @click="handleHas"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancelHas">取 消</el-button>
      </span>
    </el-dialog>
    <!--查看-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="viewDialogVisible"
      width="60%"
    >
      <div slot="title" class="title">受试者记录</div>
      <div class="proInfo" id="printbox">
        <div
          style="
            display: flex;
            margin-bottom: 20px;
            justify-content: space-between;
          "
        >
          <div class="tableItem">
            <span>单位：</span>
            <span>{{ unitName }}</span>
          </div>
          <div class="tableItem">
            <span>筛选号：</span><span>{{ choiceCode }}</span>
          </div>
          <div class="tableItem">
            <span>姓名缩写：</span><span>{{ nameAbb }}</span>
          </div>
          <div class="tableItem">
            <span>随机号：</span><span>{{ randomCode }}</span>
          </div>
        </div>
        <el-table
          size="mini"
          :data="tableData"
          border
          :header-cell-style="tableHeaderColor"
          style="width: 100%"
          :cell-style="cellStyle"
        >
          <el-table-column prop="action" label="操作" width="180" />
          <el-table-column
            prop="create_user_name"
            label="操作人员"
            width="180"
          />
          <el-table-column prop="create_time" label="随机操作时间" />
          <el-table-column prop="remarks" label="记录" />
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="goPrint">打 印</el-button>
        <el-button size="mini" type="primary" @click="handleCloseClick"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!--导出-->
    <el-dialog
      center
      :visible.sync="dialogVisibleExport"
      :close-on-click-modal="false"
      width="40%"
      @close="cancel"
    >
      <div slot="title" class="title">受试者登记信息导出</div>
      <div class="proInfo">
        <el-row :gutter="20">
          <el-col :span="6" style="text-align: right">文件类型：</el-col>
          <el-col :span="18" style="text-align: left">
            <el-radio-group v-model="the_type">
              <el-radio label="excel">excel</el-radio>
              <el-radio label="pdf">pdf</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="6" style="text-align: right">导出到：</el-col>
          <el-col :span="18" style="text-align: left">
            <el-radio-group v-model="to">
              <el-radio label="本地">本地</el-radio>
              <el-radio label="邮箱">邮箱</el-radio>
              <el-radio label="本地及邮箱">本地及邮箱</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="bottom f-r-c">
          <el-button
            v-preventReClick
            class="ok"
            :loading="loading"
            type="primary"
            @click="handleSubClick"
            >确 定</el-button
          >
          <div @click="cancel()" class="cancel">取 消</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getProjectId, getBlind, getProStatus } from "@/utils/auth";
import {
  allFall,
  fallOff,
  detail,
  logs,
  exportFile,
  subjectExportApi,
} from "@/api/subjects";
import { goPrintFn } from "@/utils/goPrintFn";
import { unitMyAllResearchCenter, getSubjectByUnit } from "@/api/unit";
export default {
  name: "FallOff",
  data() {
    return {
      HideProjects:['6528e3569c140b4bd8c79dd7','62970c755a08ad1af5d3295f','62f9f0dcc43d533bd20f99a1'],
      multipleSelection: [],
      cellStyle: {
        textAlign: "center",
      },
      currentPage: 1,
      pageSize: 10,
      is_loading: false,
      loading: false,
      unit_list: [], // 所有入组中心，用来筛选
      total: null,
      roleData: [],
      users_list: [],
      choice_code_combination_list: "",
      proId: "",
      dialogVisibleOff: false,
      reason: "",
      choice_code_combination: "",
      remarks: "",
      choiceCode: "",
      nameAbb: "",
      randomCode: "",
      doctorName: "",
      unit_id: "",
      unitName: "",
      viewDialogVisible: false,
      viewId: "",
      tableData: [],
      key: "",
      loading: false,
      options: [
        {
          label: "excel",
          value: "excel",
        },
        {
          label: "pdf",
          value: "pdf",
        },
      ],
      optionsTo: [
        {
          label: "本地",
          value: "本地",
        },
        {
          label: "邮箱",
          value: "邮箱",
        },
        {
          label: "本地及邮箱",
          value: "本地及邮箱",
        },
      ],
      the_type: "",
      to: "",
      dialogVisibleExport: false,
      project: JSON.parse(sessionStorage.getItem('iwrs_project')),
      time: "", // 脱落时间
      isBlind: true,
      blindType: "",
      statusPro: "",
      isOngoing: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.proId = getProjectId();
    // 获取项目详情
    // projectDetailApi(this, this.proId, (res) => {
    //   if (res && res.code === 0) {
    //     this.project = res.data;
    //   }
    // });
    this.blindType = getBlind();
    this.statusPro = getProStatus();
    if (this.statusPro === "项目已锁定" || this.statusPro === "项目创建中") {
      this.isOngoing = true;
    } else {
      this.isOngoing = false;
    }
    if (this.blindType === "双盲") {
      this.isBlind = false;
    } else {
      this.isBlind = true;
    }
    this.getFall();
    this.getUnitList();
  },
  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getFall, 500);
    },
  },
  methods: {
    changeUnit(ids) {
      this.choice_code_combination_list = "";
      let arr = [];
      arr[0] = ids;
      getSubjectByUnit({
        project_id: this.proId,
        unit_id_list: arr,
      }).then((res) => {
        if (res && res.success) {
          this.users_list = res.data;
        }
      });
    },
    getUnitList() {
      // 获取所有单位，用来筛选入组中心
      unitMyAllResearchCenter(this, this.proId, (res) => {
        if (res.data && res.data.length > 0) {
          this.unit_list = res.data.map((item) => {
            const obj = {};
            obj.text = item.name;
            obj.value = item.name;
            obj.id = item.id;
            obj.doctor = item.main_researchers;
            obj.enable = item.enable;
            return obj;
          });
        } else {
          this.unit_list = [];
        }
      });
    },
    handleExport() {
      this.dialogVisibleExport = true;
    },
    val() {
      if (!this.the_type) {
        this.$message({
          message: "请选择文件类型",
          type: "warning",
        });
        return false;
      }
      if (!this.to) {
        this.$message({
          message: "请选择导出地址",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    export_excel_file(export_data) {
      //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
      let blogw = new Blob([export_data], {
        type: this.$store.getters.file_type,
      });
      let link = document.createElement("a");
      let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
      link.href = objectUrl;
      link.download = this.$store.getters.file_name;
      link.click();
      window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
    },
    handleSubClick() {
      if (this.val()) {
        this.loading = true;
        let id_list = this.multipleSelection.map((item) => {
          return item.id;
        });
        if (this.to === "本地") {
          exportFile({
            project_id: this.proId,
            the_type: this.the_type,
            to: this.to,
            stype: "脱落",
            id_list,
          })
            .then((res) => {
              this.export_excel_file(res);
              this.$message({
                message: "下载成功",
                type: "success",
              });
              this.dialogVisibleExport = false;
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          const params = {
            project_id: this.proId,
            the_type: this.the_type,
            to: this.to,
            stype: "脱落",
            id_list,
          };
          if (this.to === "邮箱") {
            subjectExportApi(params)
              .then((res) => {
                if (res && res.errcode === 200) {
                  this.$message.success("发送成功");
                  this.dialogVisibleExport = false;
                }
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            exportFile(params)
              .then((res) => {
                this.export_excel_file(res);
                this.$message({
                  message: "下载成功",
                  type: "success",
                });
                this.dialogVisibleExport = false;
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      }
    },
    cancel() {
      this.dialogVisibleExport = false;
      this.to = "";
      this.the_type = "";
    },
    handleViewFall(row) {
      this.viewId = row.id;
      this.viewDialogVisible = true;
      const params = {
        project_id: this.proId,
        id: row.id,
      };
      detail(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.choiceCode = res.data.choice_code_combination;
            this.nameAbb = res.data.name_abb;
            this.randomCode = res.data.random_code_combination;
            this.unitName = res.data.unit_name;
            this.getHasLogs();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    getHasLogs() {
      const params = {
        project_id: this.proId,
        id: this.viewId,
      };
      logs(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.tableData = res.data;
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleCloseClick() {
      this.viewId = "";
      this.viewDialogVisible = false;
    },
    handleFallOff() {
      this.dialogVisibleOff = true;
    },
    getFall() {
      this.loading = true;
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
      };
      allFall(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.loading = false;
            if (res.data && res.data.length > 0) {
              this.roleData = res.data;
              this.total = res.total;
            } else {
              this.roleData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getRole();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRole();
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleHas() {
      const params = {
        project_id: this.proId,
        reason: this.reason,
        unit_id: new Array(this.unit_id),
        choice_code_combination_list: new Array(
          this.choice_code_combination_list
        ),
        time: this.moment(this.time).format("YYYY-MM-DD"),
      };
      if (
        this.reason &&
        this.unit_id &&
        this.choice_code_combination_list &&
        this.time
      ) {
        this.$confirm("此操作将脱落该受试者, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.is_loading = true;
          fallOff(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.handleCancelHas();
              } else {
                this.$message(res.msg);
              }
            })
            .finally(() => {
              this.is_loading = false;
            });
        });
      } else {
        this.$message.error("信息填写不完整");
      }
    },
    handleCancelHas() {
      this.reason = "";
      this.unit_id = "";
      this.time = "";
      this.choice_code_combination_list = "";
      this.dialogVisibleOff = false;
      this.getFall();
    },
    goPrint() {
      goPrintFn("受试者记录", "printbox");
    },
  },
};
</script>

<style lang="scss"  scoped>
@import "@/main.scss";
.ok {
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.left {
  line-height: 26px;
  text-align: right;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.sub_style .row {
  line-height: 28px;
}
.sub_style .el-col-6 {
  text-align: right;
  padding-right: 20px;
}
.sub_style .el-col-18 .el-select,
.sub_style .el-col-18 .el-date-editor {
  width: 250px;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
.diaBg {
  background-color: #f0f5ff;
  padding: 20px;
}
</style>
